export enum ActivityCardVariantEnum {
  DEFAULT = 'default',
  SHADOWLESS = 'shadowless',
}
